var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Stroke from 'ol/style/stroke';
import Fill from 'ol/style/fill';
import Style from 'ol/style/style';
import Circle from 'ol/style/circle';
import has from 'ol/has';
import { DefaultStyle } from 'ng-carta';
var pixelRatio = has.DEVICE_PIXEL_RATIO;
var SpecialStyle = /** @class */ (function (_super) {
    __extends(SpecialStyle, _super);
    function SpecialStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpecialStyle.prototype.getMainStyle = function (feature, resolution) {
        return new Style({
            stroke: this.getGradientStroke(feature, 3),
            fill: new Fill({ color: '#eb6f0050' })
        });
    };
    SpecialStyle.prototype.getSelectedStyle = function (feature, resolution) {
        return new Style({
            stroke: this.getGradientStroke(feature, 4),
            fill: new Fill({ color: '#eb6f00a0' })
        });
    };
    SpecialStyle.prototype.getDrawingStyle = function (feature, resolution) {
        return new Style({
            stroke: new Stroke({ color: 'rgba(255, 105, 0, 0.9)', width: 3 }),
            fill: new Fill({ color: '#eb6f0050' }),
            image: new Circle({
                radius: 4,
                stroke: new Stroke({ color: 'rgba(255, 105, 0, 0.9)', width: 2 }),
                fill: new Fill({ color: 'rgba(255, 105, 0, 0.3)' })
            })
        });
    };
    SpecialStyle.prototype.gradient = function (context, left, right) {
        var grad = context.createLinearGradient(left * pixelRatio, 0, right * pixelRatio, 0);
        grad.addColorStop(0, '#ffae08');
        grad.addColorStop(7 / 10, '#e30247');
        grad.addColorStop(10 / 10, '#3a87ad');
        return grad;
    };
    SpecialStyle.prototype.getGradientStroke = function (feature, width) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var leftPixel = this.getLeftPixel(feature);
        var rightPixel = this.getRightPixel(feature);
        var gradient = this.gradient(context, leftPixel, rightPixel);
        var stroke = new Stroke({ width: width });
        stroke.setColor(gradient);
        return stroke;
    };
    SpecialStyle.prototype.getLeftPixel = function (feature) {
        var extent = feature.getGeometry().getExtent();
        return this.olMap.getPixelFromCoordinate([extent[0], extent[1]])[0];
    };
    SpecialStyle.prototype.getRightPixel = function (feature) {
        var extent = feature.getGeometry().getExtent();
        return this.olMap.getPixelFromCoordinate([extent[2], extent[3]])[0];
    };
    return SpecialStyle;
}(DefaultStyle));
export { SpecialStyle };
